<script setup lang="ts" generic="T">
import type { ListBoxOption as ListBoxOptionType } from '@shared/types'
import { ListboxOption } from '@headlessui/vue'

type Props = {
    option: ListBoxOptionType<T>
}

const { option } = defineProps<Props>()
</script>

<template>
    <listbox-option
        v-slot="{ active, selected }"
        :value="option"
        as="template"
    >
        <li :class="[
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-900',
            'relative cursor-default select-none py-3 pl-10 pr-4',
        ]">
            <span :class="[
                selected ? 'font-medium' : 'font-normal',
                'block truncate',
            ]">
                {{ option.label }}
            </span>

            <i
                v-if="selected"
                class="lni lni-checkmark absolute inset-y-0 left-0 flex items-center pl-3 font-bold text-green-700"
                aria-hidden="true"
            ></i>
        </li>
    </listbox-option>
</template>
